export default "__VITE_ASSET__1e189231__"